import React from 'react';

export const CalculateBillableCosts = (item) => {
  const ESTIMATE = item?.ratesheet_id?.billable_line_items;
  const DWRS = item.dwrs;

  return DWRS.filter((dwr_item) => dwr_item.status === 1).flatMap((dwrsEntry) =>
    dwrsEntry.billing_line_items.labourCosts
      .map((dwrsItem) => {
        const estimateMatch = ESTIMATE.labourItem.find((estimateItem) => estimateItem.costItem === dwrsItem.costitem);
        if (estimateMatch) {
          const unitCost = parseFloat(estimateMatch.unitCost);
          const taskHours = parseFloat(dwrsItem.hours);
          return {
            task_id: dwrsEntry.task_id,
            costitem: dwrsItem.costitem,
            unitCost: unitCost,
            taskHours: taskHours,
            totalCost: unitCost * taskHours,
          };
        }
        return null;
      })
      .filter(Boolean)
  );
};
